import angular from 'angular';
import template from './was-this-useful-no.component.html';
var CONTACT_SUPPORT_ACTION_CODE = 'ContactSupport';
var WasThisUsefulComponentNoController = /** @class */ (function () {
    function WasThisUsefulComponentNoController() {
        this.info = {};
    }
    WasThisUsefulComponentNoController.prototype.sendResponse = function () {
        var _a, _b;
        var reason = (((_a = this.info.reason) === null || _a === void 0 ? void 0 : _a.code) || null);
        var model = { feedbackText: this.info.text, reason: reason, useful: false };
        if (angular.isUndefined(this.userName)) {
            (_b = this.wasThisUsefulController) === null || _b === void 0 ? void 0 : _b.sendModel(model, true);
        }
        if (this.isContactButtonVisible && this.contactSupportUrl) {
            window.open(this.contactSupportUrl, '_blank');
        }
    };
    WasThisUsefulComponentNoController.prototype.onNameChange = function (name) {
        this.userName = name;
    };
    WasThisUsefulComponentNoController.prototype.onReasonChange = function (reason) {
        this.info.reason = reason;
        this.info.text = '';
    };
    WasThisUsefulComponentNoController.prototype.onFeedbackTextChange = function (feedbackText) {
        this.info.text = feedbackText;
    };
    Object.defineProperty(WasThisUsefulComponentNoController.prototype, "isContactButtonVisible", {
        get: function () {
            var _a;
            return ((_a = this.info.reason) === null || _a === void 0 ? void 0 : _a.actionCode) === CONTACT_SUPPORT_ACTION_CODE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WasThisUsefulComponentNoController.prototype, "isFeedbackTextVisible", {
        get: function () {
            return Boolean(this.info.reason && this.info.reason.actionCode !== CONTACT_SUPPORT_ACTION_CODE);
        },
        enumerable: false,
        configurable: true
    });
    WasThisUsefulComponentNoController.$inject = [];
    return WasThisUsefulComponentNoController;
}());
export var WasThisUsefulNoComponent = {
    bindings: {
        contactSupportUrl: '<?',
        reasons: '<?',
    },
    controller: WasThisUsefulComponentNoController,
    require: {
        wasThisUsefulController: '^^wasThisUseful',
    },
    template: template,
};
